$(document).ready(() => {
  const searchInput = $("#searchInput");
  let activeTabId = $(".nav-link.active").attr("id");
  let allOriginalItems = $(
    `.tab-pane#${activeTabId}-tab-pane .box-card`
  ).clone();

  searchInput.on("keyup", () => {
    const valueSearch = searchInput.val().toLowerCase().trim();

    if (valueSearch !== "") {
      onSearch(allOriginalItems, valueSearch, activeTabId);
    } else {
      $(".summary-results").removeClass("d-block").addClass("d-none");
      $(".not-found-section").removeClass("d-flex").addClass("d-none");
      $(".container-items").removeClass("d-none").addClass("d-block");
      $(`.${activeTabId}-items`).empty();

      allOriginalItems.appendTo(`.${activeTabId}-items`).show();
    }
  });

  $('a[data-bs-toggle="tab"]').on("shown.bs.tab", function (e) {
    searchInput.val("");
    $(`.${activeTabId}-items`).empty();
    allOriginalItems.appendTo(`.${activeTabId}-items`).show();

    activeTabId = $(".nav-link.active").attr("id");
    allOriginalItems = $(`.tab-pane#${activeTabId}-tab-pane .box-card`).clone();

    $(".summary-results").removeClass("d-block").addClass("d-none");
  });
});

const onSearch = (allOriginalItems, value, categoryId) => {
  $(".word-search").text(value);
  $(".summary-results").removeClass("d-none").addClass("d-block");

  let numberOfMatches = 0;
  const matchingElements = [];

  allOriginalItems.each(function (index, element) {
    const productTitle = $(element).find(".item-title").text().toLowerCase();
    const productDescription = $(element)
      .find(".item-description")
      .text()
      .toLowerCase();
    const productAccordion = $(element)
      .find(".accordion-item")
      .text()
      .toLowerCase();

    if (
      productTitle.includes(value) ||
      productDescription.includes(value) ||
      productAccordion.includes(value)
    ) {
      matchingElements.push(element);
      numberOfMatches++;
    }
  });

  matchingElements.sort((a, b) => {
    const titleA = $(a).find(".item-title").text().toLowerCase();
    const titleB = $(b).find(".item-title").text().toLowerCase();

    return titleA.localeCompare(titleB);
  });

  $(`.${categoryId}-items`).empty();

  matchingElements.forEach((element) => {
    $(`.${categoryId}-items`).append(element);
  });

  $(".length-results").text(numberOfMatches);

  if (numberOfMatches === 0) {
    $(".not-found-section").removeClass("d-none").addClass("d-flex");
    $(".container-items").removeClass("d-block").addClass("d-none");
  } else {
    $(".not-found-section").removeClass("d-flex").addClass("d-none");
    $(".container-items").removeClass("d-none").addClass("d-block");
  }
};
